import { IMingaFeatureToggleKeys } from 'libs/domain';
import { MingaPermission } from 'libs/domain';
import { z } from 'zod';

import { PsHallPassData, PsBehaviorsData, PsCheckinData, PsFlexTimeActivitiesData } from '@modules/people-selector';

import { ModalOverlayPrimaryHeaderBackground } from '@shared/components/modal-overlay';

export type SaAssignOverlayConfig = {
  formTitle: string;
  selfAssignTitle?: string;
  formHeaderBg: ModalOverlayPrimaryHeaderBackground;
  tabbedHeader: boolean;
} & (
  | {
      tabbedHeader: true;
      data: TabSaPageData[];
    }
  | {
      tabbedHeader: false;
      data: BaseSaPageData;
    }
);

export type BaseSaPageData = {
  carouselTitle: string;
  filterField: boolean;
  filterInfo: FilterSaPageData;
  permissions?: MingaPermission[];
  requiredModule?: IMingaFeatureToggleKeys;
};

export type FilterSaPageData = {
  filterPlaceholder: string;
  filterEmptyHeading: string;
  filterEmptyMsg: string;
};

export type TabSaPageData = {
  selector: SaSelectorTypes;
  title: string;
  icon: string;
  color: string;
} & BaseSaPageData;

export type CarouselTileData = {
  type: SaSelectorTypes;
  id: number;
  name: string;
  icon: string;
  color: string;
  iconNamespace?: string;
} & (
  | {
      type: 'hall-pass';
      duration: number;
      requireTeacherApproval: boolean;
      canSelfAssign: boolean;
    }
  | { type: 'flex-activity'; periodId: number }
  | { type: 'consequence'; canAddNote: boolean; enableDueDate: boolean }
  | {
      type: Exclude<SaSelectorTypes, 'hall-pass' | 'flex-activity' | 'consequence'>;
    }
);

export const SaFormMap = {
  'hall-pass': {} as PsHallPassData,
  praise: {} as PsBehaviorsData,
  guidance: {} as PsBehaviorsData,
  consequence: {} as PsBehaviorsData,
  checkin: {} as PsCheckinData,
  'flex-activity': {} as PsFlexTimeActivitiesData & { name: string },
} as const;

export type SaSelectorTypes = keyof typeof SaFormMap;

export type Tile = {
  type: SaSelectorTypes;
  id: number;
  name: string;
  tooltip?: string;
  icon?: string;
  color: string;
  iconNamespace?: string;
  assetPath?: string;
  disabled?: boolean;

};

export const selectionAssignerSchema = z.object({
  tab: z.enum(Object.keys(SaFormMap) as [SaSelectorTypes]).optional(),
  importBehaviors: z.boolean().optional().catch(false),
  originUrl: z.string().optional(),
});

export type SelectionAssignerQueryParams = z.infer<typeof selectionAssignerSchema>;
